<template>
  <iColumn
    class="nav-items"
    vertical-align="middle"
    :width="getOptionValue(LayoutWidth)"
    :height="getOptionValue(LayoutHeight)"
    @click="handleClick"
  >
    <iMenu
      :items="navConfig"
      :orientation="myOrientation"
      :gap="myGap"
      :menu-item-text-attrs="menuItemTextAttrs"
      :menu-item-style-overrides="menuItemStyleOverrides"
      :icon-style-attr="iconAttr"
    />
  </iColumn>
</template>

<script>
import { PageHeaderElementMixin } from "~/dynamic-components/standard-components/page-header/page-header-element-mixin";
import NavConfig from "~/dynamic-components/options/nav-config.js";
import MenuOrientation from "~/dynamic-components/options/menu-orientation";
import { PrimaryNavigationMixin } from "~/dynamic-components/shared-elements/navigation/primary-navigation-mixin";
import LayoutGap from "%/dynamic-components/render-engine/options/layout-options/layout-gap";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import BrandedTextStyleOptions from "%/dynamic-components/render-engine/bundles/branded-text-style-options";
import BasicTextOptions from "%/dynamic-components/render-engine/bundles/basic-text-options";
import TextOptions from "%/dynamic-components/render-engine/bundles/text-options";
import SpacingOptions from "%/dynamic-components/render-engine/bundles/spacing-options";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";
import AnimationEffectsOptions from "%/dynamic-components/render-engine/bundles/animation-effects-options";

export default {
  name: "PrimaryNavigation",
  mixins: [PageHeaderElementMixin, PrimaryNavigationMixin],
  elementPanelSettings: {
    displayName: "Primary Navigation",
    displayIcon: "arrow-up",
    elementGroup: "general",
    elementType: "element",
  },
  optionsOrder: [
    "nav-config",
    "menu-orientation",
  ],
  optionBundles: [
    AppearanceOptions,
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
    BasicTextOptions,
    TextOptions,
    new SpacingOptions({
      "default.padding": {
        "top": null,
        "left": null,
        "bottom": null,
        "right": null,
      },
    }),
    AnimationEffectsOptions,
  ],
  data() {
    return {
      LayoutWidth,
      LayoutHeight,
    };
  },
  options: [
    new LayoutHeight({ default: "hug" }, true),
    new LayoutWidth({ default: "hug" }, true),
    new LayoutGap({ default: "none" }, false, true, false),
    NavConfig,
    MenuOrientation,
  ],
  computed: {
    myGap() {
      return this.getOptionValue(LayoutGap);
    },
    myOrientation() {
      return this.getOptionValue(MenuOrientation);
    },
    menuTextStyleOverrides() {
      return Object.entries(this.textOnlyAttributes.textStyleOverrides || {}).reduce((cleaned, [key, value]) => {
        if (value === null || value === undefined) {
          return cleaned;
        }

        cleaned[key] = value;
        return cleaned;
      }, {});
    },
    menuItemTextAttrs() {
      const textAttrs = { ...this.textOnlyAttributes };

      if (textAttrs.fontSize === null || textAttrs.fontSize === undefined) {
        delete textAttrs.fontSize;
      }

      return {
        ...textAttrs,
        styleOverrides: this.menuTextStyleOverrides,
      };
    },
    iconAttr() {
      return {
        styleOverrides: {
          primaryVariantColor: this.fontColor,
        },
        size: this.fontSizeNumberValue,
      };
    },
    menuItemStyleOverrides() {
      const styleOverrides = {
        standardNavLinkFontSize: this.menuTextStyleOverrides.standardFontSize,
        navLinkFontColor: this.menuTextStyleOverrides.standardFontColor,
        navLinkFontWeight: this.menuTextStyleOverrides.standardFontWeight,
        navLinkFontFamily: this.menuTextStyleOverrides.standardFontFamily,
        standardNavLinkHoverFontSize: this.menuTextStyleOverrides.standardHoverFontSize,
        navLinkHoverFontColor: this.menuTextStyleOverrides.standardHoverFontColor,
        navLinkHoverFontWeight: this.menuTextStyleOverrides.standardHoverFontWeight,
        navLinkHoverFontFamily: this.menuTextStyleOverrides.standardHoverFontFamily,
        menuItemPaddingTop: this.spacingStyleOverrides.paddingTop,
        menuItemPaddingRight: this.spacingStyleOverrides.paddingRight,
        menuItemPaddingBottom: this.spacingStyleOverrides.paddingBottom,
        menuItemPaddingLeft: this.spacingStyleOverrides.paddingLeft,
        menuItemMarginTop: this.spacingStyleOverrides.marginTop,
        menuItemMarginRight: this.spacingStyleOverrides.marginRight,
        menuItemMarginBottom: this.spacingStyleOverrides.marginBottom,
        menuItemMarginLeft: this.spacingStyleOverrides.marginLeft,
        menuItemHoverBackgroundColor: "none",
      };

      return Object.entries(styleOverrides).reduce((cleaned, [key, value]) => {
        if (value === null || value === undefined) {
          return cleaned;
        }

        cleaned[key] = value;
        return cleaned;
      }, {});
    },
  },
  methods: {
    handleClick(event) {
      if (this.editMode) {
        event.preventDefault();
      }
    },
  },
};
</script>
